import { useRouter } from "expo-router";
import { View } from "react-native";

import { Button } from "@/shared/components/ui/button";
import { ScreenContainer } from "@/shared/components/ui/screen-container";
import { Image } from "expo-image";

export default function WelcomeScreen() {
  const router = useRouter();

  return (
    <ScreenContainer className="items-center justify-center">
      <Image
        source={require("../../assets/logo.png")}
        style={{ width: 300, height: 200 }}
        accessibilityLabel="LEZZ logo"
        contentFit="contain"
      />

      <View className="absolute inset-x-6 bottom-20 gap-3">
        <Button size="lg" onPress={() => router.push("/login")}>
          Entrar
        </Button>
        <Button
          size="lg"
          variant="outline"
          onPress={() => router.push("/signup")}
        >
          Cadastrar
        </Button>
      </View>
    </ScreenContainer>
  );
}
